import { TransactionDashboard as Component } from './component';
import Connector from './connector';
import { ConnectorProps } from './TransactionDashboard.proptype';

export interface TransactionDashboardProps extends Omit<ConnectorProps, 'component'> {}

export const TransactionDashboard = (props: TransactionDashboardProps) => (
  <Connector {...props} component={Component} />
);
